var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, select, compile, NotifyPropertyChanges, isNullOrUndefined as isNOU, formatUnit, Event, append, addClass, removeClass, Property, ChildProperty, Collection } from '@syncfusion/ej2-base';
import { attributes, EventHandler, remove } from '@syncfusion/ej2-base';
/**
 * Represents a toolbar item model in the component.
 */
export class ToolbarItem extends ChildProperty {
}
__decorate([
    Property('')
], ToolbarItem.prototype, "iconCss", void 0);
__decorate([
    Property()
], ToolbarItem.prototype, "text", void 0);
__decorate([
    Property('Button')
], ToolbarItem.prototype, "type", void 0);
__decorate([
    Property('Left')
], ToolbarItem.prototype, "align", void 0);
__decorate([
    Property(true)
], ToolbarItem.prototype, "visible", void 0);
__decorate([
    Property(false)
], ToolbarItem.prototype, "disabled", void 0);
__decorate([
    Property('')
], ToolbarItem.prototype, "tooltip", void 0);
__decorate([
    Property('')
], ToolbarItem.prototype, "cssClass", void 0);
__decorate([
    Property(null)
], ToolbarItem.prototype, "template", void 0);
__decorate([
    Property(-1)
], ToolbarItem.prototype, "tabIndex", void 0);
/**
 * Represents the settings for the toolbar in the component.
 */
export class ToolbarSettings extends ChildProperty {
}
__decorate([
    Collection([], ToolbarItem)
], ToolbarSettings.prototype, "items", void 0);
__decorate([
    Event()
], ToolbarSettings.prototype, "itemClicked", void 0);
/**
 * ChatBase component act as base class.
 */
let InterActiveChatBase = class InterActiveChatBase extends Component {
    /**
     * * Constructor for Base class
     *
     * @param {InterActiveChatBaseModel} options - Specifies the Base model.
     * @param {string | HTMLElement} element - Specifies the element to render as component.
     * @private
     */
    constructor(options, element) {
        super(options, element);
        this.undoStack = [];
        this.redoStack = [];
        this.undoDelayTimer = null;
    }
    /**
     * This method is abstract member of the Component<HTMLElement>.
     *
     * @private
     * @returns {void}
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    preRender() {
    }
    /**
     * This method is abstract member of the Component<HTMLElement>.
     *
     * @private
     * @returns {string} - It returns the current module name.
     */
    getModuleName() {
        return 'interactivechatBase';
    }
    /**
     * This method is abstract member of the Component<HTMLElement>.
     *
     * @private
     * @returns {string} - It returns the persisted data.
     */
    getPersistData() {
        return this.addOnPersist([]);
    }
    /**
     * This method is abstract member of the Component<HTMLElement>.
     *
     * @private
     * @returns {void}
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    render() {
    }
    /* To calculate the width when change via set model */
    setDimension(element, width, height) {
        element.style.width = !isNOU(width) ? formatUnit(width) : element.style.width;
        element.style.height = !isNOU(height) ? formatUnit(height) : element.style.height;
    }
    addCssClass(element, cssClass) {
        if (cssClass) {
            element.classList.add(cssClass);
        }
    }
    addRtlClass(element, isRtl) {
        if (isRtl) {
            element.classList.add('e-rtl');
        }
    }
    updateCssClass(element, newClass, oldClass) {
        if (oldClass) {
            removeClass([element], oldClass.trim().split(' '));
        }
        if (newClass) {
            addClass([element], newClass.trim().split(' '));
        }
    }
    updateHeader(showHeader, headerElement, viewWrapper) {
        if (!showHeader) {
            headerElement.hidden = true;
            viewWrapper.style.height = '100%';
        }
        else {
            headerElement.hidden = false;
            viewWrapper.style.height = '';
        }
    }
    renderViewSections(element, headerClassName, viewClassName) {
        const headerWrapper = this.createElement('div', { className: headerClassName });
        element.appendChild(headerWrapper);
        const viewWrapper = this.createElement('div', { className: viewClassName });
        element.appendChild(viewWrapper);
    }
    createViewComponents(viewWrapper) {
        const contentWrapper = this.createElement('div', { className: 'e-views' });
        const viewContainer = this.createElement('div', { className: 'e-view-container' });
        contentWrapper.appendChild(viewContainer);
        viewWrapper.appendChild(contentWrapper);
    }
    updateScroll(scrollElement) {
        scrollElement.scrollTo(0, scrollElement.scrollHeight);
    }
    getElement(element) {
        let className;
        switch (element) {
            case 'footer':
                className = 'e-footer';
                break;
            case 'contentContainer':
                className = 'e-content-container';
                break;
            case 'outputElement':
                className = 'e-content';
                break;
            default:
                className = '';
                break;
        }
        return this.createElement('div', { className: className });
    }
    getClipBoardContent(value) {
        const tempElement = document.createElement('div');
        tempElement.innerHTML = value;
        tempElement.style.top = '0';
        tempElement.style.left = '0';
        tempElement.style.position = 'fixed';
        tempElement.style.opacity = '0';
        document.body.appendChild(tempElement);
        navigator.clipboard.write([
            new ClipboardItem({
                'text/html': new Blob([tempElement.innerHTML], { type: 'text/html' }),
                'text/plain': new Blob([tempElement.innerText], { type: 'text/plain' })
            })
        ]);
        document.body.removeChild(tempElement);
    }
    writeFileToClipboard(file) {
        if (!document.hasFocus() || !('clipboard' in navigator)) {
            return;
        }
        const mimeType = file.type;
        const supportedTypes = ['image/png'];
        if (supportedTypes.includes(mimeType)) {
            void navigator.clipboard.write([
                new ClipboardItem({ [mimeType]: file })
            ]);
            return;
        }
        const img = new Image();
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            canvas.toBlob((blob) => {
                if (blob) {
                    void navigator.clipboard.write([
                        new ClipboardItem({ [blob.type]: blob })
                    ]);
                }
            }, 'image/png');
        };
        img.src = URL.createObjectURL(file);
    }
    getFooter() {
        this.footer = this.getElement('footer');
    }
    createSuggestionElement(suggestionHeader) {
        const suggestionContainer = this.createElement('div', { className: 'e-suggestions' });
        const suggestionHeaderElement = this.createElement('div', { className: 'e-suggestion-header' });
        const suggestionListElement = this.createElement('div', { className: 'e-suggestion-list' });
        if (suggestionHeader) {
            suggestionContainer.appendChild(suggestionHeaderElement);
        }
        suggestionContainer.appendChild(suggestionListElement);
        return { suggestionContainer, suggestionHeaderElement, suggestionListElement };
    }
    renderSuggestions(suggestionsArray, suggestionHeader, suggestionTemplate, contextName, templateName, onSuggestionClick) {
        const isSuggestionTemplate = suggestionTemplate ? true : false;
        if (suggestionsArray && suggestionsArray.length > 0) {
            const { suggestionContainer, suggestionHeaderElement, suggestionListElement } = this.createSuggestionElement(suggestionHeader);
            this.suggestionsElement = suggestionContainer;
            const suggestionContainerClass = `e-suggestions ${isSuggestionTemplate ? 'e-suggestion-item-template' : ''}`;
            this.suggestionsElement.className = suggestionContainerClass;
            this.suggestionHeader = suggestionHeaderElement;
            const suggestionList = suggestionListElement;
            this.renderSuggestionList(suggestionsArray, suggestionList, isSuggestionTemplate, contextName, suggestionTemplate, templateName, onSuggestionClick);
            if (suggestionHeader) {
                this.suggestionHeader.innerHTML = suggestionHeader;
            }
            this.suggestionsElement.append(suggestionList);
            this.content.append(this.suggestionsElement);
        }
    }
    renderSuggestionList(suggestionsArray, suggestionWrapper, isSuggestionTemplate, contextName, suggestionTemplate, templateName, onSuggestionClick) {
        const suggestionsListElement = this.createElement('ul', { attrs: { 'tabindex': '-1' } });
        suggestionsArray.forEach((suggestion, i) => {
            const suggestionList = this.createElement('li');
            attributes(suggestionList, { 'tabindex': '0' });
            EventHandler.add(suggestionList, 'click', (event) => { onSuggestionClick.call(this, event, suggestion); }, this);
            EventHandler.add(suggestionList, 'keydown', (event) => this.suggestionItemHandler(event, suggestion), this);
            if (isSuggestionTemplate) {
                const suggestionContext = { index: i, [contextName]: suggestionsArray[parseInt(i.toString(), 10)] };
                this.updateContent(suggestionTemplate, suggestionList, suggestionContext, templateName);
            }
            else {
                suggestionList.innerHTML = suggestion;
            }
            suggestionsListElement.append(suggestionList);
        });
        suggestionWrapper.appendChild(suggestionsListElement);
    }
    suggestionItemHandler(event, suggestionText) {
        if (event.key === 'Enter' && !event.shiftKey) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.onSuggestionClick(event, suggestionText);
        }
    }
    renderBannerView(bannerTemplate, parentElement, templateName) {
        if (bannerTemplate) {
            const className = templateName === 'emptyChatTemplate' ? 'e-empty-chat-template' : 'e-banner-view';
            const introContainer = this.createElement('div', { className: className });
            this.updateContent(bannerTemplate, introContainer, {}, templateName);
            parentElement.prepend(introContainer);
        }
    }
    updateContent(template, contentElement, context, templateName) {
        if (this.isReact) {
            this.clearTemplate([templateName]);
        }
        const notCompile = !(this.isReact || this.isVue);
        const ctn = this.getTemplateFunction(template, notCompile);
        if (typeof ctn === 'string') {
            contentElement.innerHTML = ctn;
        }
        else {
            append(ctn(context, this), contentElement);
        }
        this.renderReactTemplates();
    }
    renderFooterContent(footerTemplate, prompt, promptPlaceholder, showClearButton, className) {
        if (footerTemplate) {
            this.updateContent(footerTemplate, this.footer, {}, 'footerTemplate');
        }
        else {
            this.renderFooter(className, prompt, promptPlaceholder, showClearButton);
        }
    }
    renderFooter(className, prompt, promptPlaceholder, showClearButton = false) {
        this.editableTextarea = this.createElement('div', {
            attrs: {
                class: className,
                contenteditable: 'true',
                placeholder: promptPlaceholder,
                role: 'textbox',
                'aria-multiline': 'true'
            },
            innerHTML: prompt
        });
        const hiddenTextarea = this.createElement('textarea', {
            attrs: {
                class: 'e-hidden-textarea',
                name: 'userPrompt',
                value: prompt
            }
        });
        const textAreaIconsWrapper = this.createElement('div', { className: 'e-textarea-icons-wrapper' });
        this.appendChildren(textAreaIconsWrapper, this.editableTextarea, hiddenTextarea);
        this.footer.appendChild(textAreaIconsWrapper);
    }
    updateTextAreaObject(textareaObj) {
        if (isNOU(textareaObj)) {
            return;
        }
        const textarea = textareaObj.element;
        textarea.style.height = 'auto';
        textarea.style.height = textarea.scrollHeight + 'px';
    }
    renderSendIcon(sendIconClass) {
        const sendIcon = this.createElement('span', { attrs: { class: sendIconClass, role: 'button', 'aria-label': 'Submit', tabindex: '0' } });
        this.footer.appendChild(sendIcon);
        return sendIcon;
    }
    appendChildren(target, ...children) {
        target.append(...children);
    }
    insertBeforeChildren(target, ...children) {
        target.prepend(...children);
    }
    renderFooterIcons(sendIconClass, showClearButton, clearIconClass) {
        const footerIconsWrapper = this.createElement('div', { attrs: { class: 'e-footer-icons-wrapper' } });
        this.sendIcon = this.createElement('span', { attrs: { class: sendIconClass, role: 'button', 'aria-label': 'Submit', tabindex: '0' } });
        footerIconsWrapper.appendChild(this.sendIcon);
        if (showClearButton) {
            this.renderClearIcon(footerIconsWrapper, clearIconClass);
        }
        this.footer.firstChild.appendChild(footerIconsWrapper);
        this.footer.classList.add('e-footer-focus-wave-effect');
    }
    renderClearIcon(footerIconsWrapper, clearIconClass) {
        this.clearIcon = this.createElement('span', { attrs: { class: clearIconClass, role: 'button', 'aria-label': 'Close', tabindex: '-1' } });
        if (footerIconsWrapper) {
            footerIconsWrapper.prepend(this.clearIcon);
        }
    }
    checkScrollAtBottom(Element, fabHeight) {
        const scrollThreshold = 5;
        const scrollTop = Math.floor(Element.scrollTop);
        const scrollHeight = Math.floor(Element.scrollHeight);
        const clientHeight = Math.floor(Element.clientHeight);
        return scrollHeight - scrollTop <= clientHeight + scrollThreshold + fabHeight;
    }
    updateHiddenTextarea(prompt) {
        const hiddenTextarea = this.footer.querySelector('.e-hidden-textarea');
        hiddenTextarea.value = prompt;
    }
    activateSendIcon(value) {
        this.sendIcon.classList.toggle('disabled', value === 0);
        this.sendIcon.classList.toggle('enabled', value > 0);
    }
    updateFooterElementClass() {
        if (isNOU(this.editableTextarea)) {
            return;
        }
        const textarea = this.editableTextarea;
        textarea.style.height = 'auto';
        this.footer.classList.remove('e-footer-expanded');
        this.footer.classList[textarea.scrollHeight > parseInt(getComputedStyle(textarea).minHeight, 10) ? 'add' : 'remove']('e-footer-expanded');
    }
    updatePlaceholder(placeholder) {
        if (this.editableTextarea) {
            this.editableTextarea.setAttribute('placeholder', placeholder);
        }
    }
    pushToUndoStack(value) {
        const { start, end } = this.getCursorPosition();
        const state = {
            content: value,
            selectionStart: start,
            selectionEnd: end
        };
        if (this.undoStack.length === 0 || this.undoStack[this.undoStack.length - 1].content !== value) {
            this.undoStack.push(state);
            if (this.undoStack.length > 100) {
                this.undoStack.shift();
            }
        }
    }
    handleUndoRedo(event) {
        const isUndo = (event.ctrlKey || event.metaKey) && event.key === 'z' && !event.shiftKey;
        const isRedo = (event.ctrlKey || event.metaKey) && (event.key === 'y' || (event.key === 'z' && event.shiftKey));
        if (isUndo) {
            event.preventDefault();
            this.undo(event);
        }
        else if (isRedo) {
            event.preventDefault();
            this.redo(event);
        }
    }
    undo(event) {
        if (this.undoStack.length <= 1) {
            return;
        }
        const current = this.undoStack.pop();
        const previous = this.undoStack[this.undoStack.length - 1];
        this.redoStack.push(current);
        this.applyPromptChange(previous, current, event);
    }
    redo(event) {
        if (this.redoStack.length === 0) {
            return;
        }
        const current = {
            content: this.editableTextarea.textContent,
            selectionStart: this.getCursorPosition().start,
            selectionEnd: this.getCursorPosition().end
        };
        const next = this.redoStack.pop();
        this.undoStack.push(next);
        this.applyPromptChange(next, current, event);
    }
    setFocusAtEnd(textArea) {
        const range = document.createRange();
        const selection = window.getSelection();
        range.selectNodeContents(textArea);
        range.collapse(false);
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }
    getCursorPosition() {
        const selection = window.getSelection();
        if (!selection || selection.rangeCount === 0) {
            return { start: 0, end: 0 };
        }
        const range = selection.getRangeAt(0);
        const { startContainer, startOffset, endContainer, endOffset } = range;
        let charCount = 0;
        let start = -1;
        let end = -1;
        if (this.editableTextarea !== null) {
            const walker = document.createTreeWalker(this.editableTextarea, NodeFilter.SHOW_TEXT, null);
            let currentNode = walker.nextNode();
            while (currentNode !== null) {
                if (currentNode === startContainer) {
                    start = charCount + startOffset;
                }
                if (currentNode === endContainer) {
                    end = charCount + endOffset;
                }
                if (start !== -1 && end !== -1) {
                    break;
                }
                charCount += currentNode.textContent.length;
                currentNode = walker.nextNode();
            }
        }
        if (start === -1) {
            start = 0;
        }
        if (end === -1) {
            end = 0;
        }
        return { start, end };
    }
    findTextNodeAndOffset(element, targetOffset) {
        // TreeWalker is a robust way to traverse all text nodes in the element's subtree
        const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null);
        let currentNode = walker.nextNode();
        let cumulativeOffset = 0;
        while (currentNode !== null) {
            const nodeLength = currentNode.textContent.length;
            if (cumulativeOffset + nodeLength >= targetOffset) {
                return { node: currentNode, offset: targetOffset - cumulativeOffset };
            }
            cumulativeOffset += nodeLength;
            currentNode = walker.nextNode();
        }
        walker.currentNode = element;
        const lastNode = walker.lastChild();
        if (lastNode) {
            return { node: lastNode, offset: lastNode.textContent.length };
        }
        return null; // Should not happen if the element is not empty
    }
    setCursorPosition(start, end) {
        const selection = window.getSelection();
        if (!selection) {
            return;
        }
        const startNodeInfo = this.findTextNodeAndOffset(this.editableTextarea, start);
        const endNodeInfo = this.findTextNodeAndOffset(this.editableTextarea, end);
        if (startNodeInfo && endNodeInfo) {
            const range = document.createRange();
            range.setStart(startNodeInfo.node, startNodeInfo.offset);
            range.setEnd(endNodeInfo.node, endNodeInfo.offset);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }
    clearBreakTags(element) {
        element.innerHTML = element.innerHTML.replace(/<br>/g, '').trim();
    }
    handlePaste(event) {
        event.preventDefault(); // Prevent default paste behavior
        const pasteContent = event.clipboardData.getData('text/plain') || '';
        const selection = window.getSelection();
        if (!selection || selection.rangeCount === 0) {
            return;
        }
        const range = selection.getRangeAt(0);
        range.deleteContents(); // Delete any selected text
        // Handle line breaks with proper typing
        const lines = pasteContent.split(/\r?\n/);
        const fragment = document.createDocumentFragment();
        lines.forEach((line, index) => {
            if (line) { // Only add non-empty lines
                fragment.appendChild(document.createTextNode(line));
            }
            if (index < lines.length - 1) {
                fragment.appendChild(document.createElement('br'));
            }
        });
        range.insertNode(fragment);
        this.setFocusAtEnd(this.editableTextarea);
        // Clear redo stack on new input
        this.redoStack = [];
        const inputEvent = new CustomEvent('input', {
            bubbles: true,
            cancelable: true,
            detail: {
                inputType: 'insertFromPaste',
                data: this.editableTextarea.innerText,
                isComposing: false
            }
        });
        this.editableTextarea.dispatchEvent(inputEvent);
        this.pushToUndoStack(this.editableTextarea.innerHTML);
        this.updateScroll(this.editableTextarea);
    }
    getCurrentState() {
        const position = this.getCursorPosition();
        return {
            content: this.editableTextarea !== null ? this.editableTextarea.innerHTML : '',
            selectionStart: position.start,
            selectionEnd: position.end
        };
    }
    scheduleUndoPush() {
        if (this.undoDelayTimer) {
            clearTimeout(this.undoDelayTimer);
        }
        this.undoDelayTimer = setTimeout(() => {
            const lastState = this.undoStack[this.undoStack.length - 1];
            const currentState = this.getCurrentState();
            if (!lastState || lastState.content !== currentState.content) {
                this.undoStack.push(currentState);
            }
        }, 400);
    }
    renderFailureAlert(viewWrapper, failureMessage, failureType, circleCloseIconClass, closeIconClass) {
        const alertElement = this.createElement('div', {
            className: 'e-upload-failure-alert',
            innerHTML: `
                <span class="e-icons ${circleCloseIconClass}" aria-label="Upload failure"></span>
                <div class="e-failure-message ${failureType}">${failureMessage}</div>
                <span class="e-icons ${closeIconClass}" role="button" tabindex="0" aria-label="Close"></span>
            `
        });
        EventHandler.add(alertElement, 'click', () => { this.handleFailureAlertRemove(viewWrapper, alertElement); }, this);
        return alertElement;
    }
    handleFailureAlertRemove(viewWrapper, alertElement) {
        alertElement.classList.remove('e-show');
        EventHandler.remove(alertElement, 'click', this.handleFailureAlertRemove);
        if (viewWrapper && viewWrapper.contains(alertElement)) {
            viewWrapper.removeChild(alertElement);
        }
    }
    wireFooterEvents(footerTemplate) {
        if (this.sendIcon) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            EventHandler.add(this.sendIcon, 'click', this.onSendIconClick, this);
        }
        if (this.footer && !footerTemplate) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            EventHandler.add(this.footer, 'keydown', this.footerKeyHandler, this);
        }
        if (this.editableTextarea) {
            EventHandler.add(this.editableTextarea, 'focus', this.onFocusEditableTextarea, this);
            EventHandler.add(this.editableTextarea, 'blur', this.onBlurEditableTextarea, this);
            EventHandler.add(this.editableTextarea, 'paste', this.handlePaste, this);
            EventHandler.add(this.editableTextarea, 'input', this.handleInput, this);
            EventHandler.add(window, 'resize', this.updateFooterElementClass, this);
        }
    }
    unWireFooterEvents(footerTemplate) {
        if (this.sendIcon) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            EventHandler.remove(this.sendIcon, 'click', this.onSendIconClick);
        }
        if (this.footer && !footerTemplate) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            EventHandler.remove(this.footer, 'keydown', this.footerKeyHandler);
        }
        if (this.editableTextarea) {
            EventHandler.remove(this.editableTextarea, 'focus', this.onFocusEditableTextarea);
            EventHandler.remove(this.editableTextarea, 'blur', this.onBlurEditableTextarea);
            EventHandler.remove(this.editableTextarea, 'paste', this.handlePaste);
            EventHandler.remove(this.editableTextarea, 'input', this.handleInput);
            EventHandler.remove(window, 'resize', this.updateFooterElementClass);
        }
    }
    removeAndNullify(element) {
        if (element) {
            if (!isNOU(element.parentNode)) {
                remove(element);
            }
            else {
                element.innerHTML = '';
            }
        }
    }
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    destroyAndNullify(obj) {
        if (obj) {
            obj.destroy();
            obj = null;
        }
    }
    /**
     * Gets template content based on the template property value.
     *
     * @param {string | Function} template - Template property value.
     * @param {boolean} notCompile - Compile property value.
     * @returns {Function} - Return template function.
     * @hidden
     */
    getTemplateFunction(template, notCompile) {
        if (typeof template === 'string') {
            let content = '';
            try {
                const tempEle = select(template);
                if (tempEle) {
                    //Return innerHTML incase of jsrenderer script else outerHTML
                    content = tempEle.tagName === 'SCRIPT' ? tempEle.innerHTML : tempEle.outerHTML;
                    notCompile = false;
                }
                else {
                    content = template;
                }
            }
            catch (e) {
                content = template;
            }
            return notCompile ? content : compile(content);
        }
        else {
            /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
            return compile(template);
        }
    }
    /**
     * This method is abstract member of the Component<HTMLElement>.
     *
     * @param  {InterActiveChatBaseModel} newProp - Specifies new properties
     * @param  {InterActiveChatBaseModel} oldProp - Specifies old properties
     * @private
     * @returns {void}
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
    onPropertyChanged(newProp, oldProp) {
    }
};
__decorate([
    Event()
], InterActiveChatBase.prototype, "created", void 0);
InterActiveChatBase = __decorate([
    NotifyPropertyChanges
], InterActiveChatBase);
export { InterActiveChatBase };
